import { Type } from '@angular/core';
import { ConversationalNotificationComponent } from '../conversational-notification/conversational-notification.component';
import { InformationalNotificationComponent } from '../informational-notification/informational-notification.component';
import { NotificationContext } from '../notification.context';

export enum NOTIFICATION_BUTTON_ACTIONS {
  confirmAction = 'confirmAction',
  rejectAction = 'rejectAction',
  deleteNotification = 'deleteNotification',
}

export enum NOTIFICATION_ACTION_TYPES {
  user_get_connection_invitation = 'USER_GET_CONNECTION_INVITATION',
  invite_to_project = 'INVITE_TO_PROJECT',
  request_to_join_project = 'REQUEST_TO_JOIN_PROJECT',
  request_to_project_accepted = 'REQUEST_TO_JOIN_PROJECT_ACCEPTED',
  request_to_project_decline = 'REQUEST_TO_JOIN_PROJECT_DECLINED',
  user_updated_reactivation_petition = 'USER_UPDATED_REACTIVATION_PETITION',
  user_connection_invitation_accepts = 'USER_CONNECTION_INVITATION_ACCEPTS',
  invite_to_project_accepted = 'INVITE_TO_PROJECT_ACCEPTED',
  invite_to_project_decline = 'INVITE_TO_PROJECT_DECLINE',
  invite_to_project_accepted_by_any_owner = 'INVITE_TO_PROJECT_ACCEPTED_BY_ANY_OWNER',
  invite_to_project_decline_by_any_owner = 'INVITE_TO_PROJECT_DECLINE_BY_ANY_OWNER',
  project_member_left = 'PROJECT_MEMBER_LEFT',
  project_member_excluded = 'PROJECT_MEMBER_EXCLUDED',
  post_commented = 'POST_COMMENTED',
  comment_reply = 'COMMENT_REPLY',
  post_lead_commented = 'POST_LEAD_COMMENT',
  file_shared = 'FILE_SHARED',
  invite_to_community = 'INVITE_TO_COMMUNITY',
  member_left_community = 'MEMBER_LEFT_COMMUNITY',
  invitation_to_join_community_accepted = 'INVITATION_TO_JOIN_COMMUNITY_ACCEPTED',
  invitation_to_join_community_declined = 'INVITATION_TO_JOIN_COMMUNITY_DECLINED',
  request_to_join_community = 'REQUEST_TO_JOIN_COMMUNITY',
  request_to_join_community_approved = 'REQUEST_TO_JOIN_COMMUNITY_APPROVED',
  request_to_join_community_declined = 'REQUEST_TO_JOIN_COMMUNITY_DECLINED',
  community_member_removed = 'COMMUNITY_MEMBER_REMOVED',
  doctor_patient_link_added = 'DOCTOR_PATIENT_LINK_REQUEST_ADDED',
  doctor_patient_link_accepted = 'DOCTOR_PATIENT_LINK_REQUEST_ACCEPTED',
  doctor_patient_link_rejected = 'DOCTOR_PATIENT_LINK_REQUEST_REJECTED',
  doctor_patient_link_removed = 'DOCTOR_PATIENT_LINK_REQUEST_REMOVED',
  patient_role_removed = 'PATIENT_ROLE_REMOVED',
  doctor_role_removed = 'DOCTOR_ROLE_REMOVED',
  category_renamed = 'CATEGORY_RENAMED',
}

export const NOTIFICATION_INVERTED_COMPONENT_TYPES: { [key: string]: Type<NotificationContext> } = {
  'com.dntl.1l2c.user_get_connection_invitation': ConversationalNotificationComponent,
  'com.dntl.1l2c.user_connection_invitation_accepts': InformationalNotificationComponent,
  'com.dntl.1l2c.invite_to_project': ConversationalNotificationComponent,
  'com.dntl.1l2c.invite_to_project_accepted': InformationalNotificationComponent,
  'com.dntl.1l2c.invite_to_project_decline': InformationalNotificationComponent,
  'com.dntl.1l2c.invite_to_project_accepted_by_any_owner': InformationalNotificationComponent,
  'com.dntl.1l2c.invite_to_project_decline_by_any_owner': InformationalNotificationComponent,
  'com.dntl.1l2c.request_to_join_project': ConversationalNotificationComponent,
  'com.dntl.1l2c.request_to_project_accepted': InformationalNotificationComponent,
  'com.dntl.1l2c.request_to_project_decline': InformationalNotificationComponent,
  'com.dntl.1l2c.user_updated_reactivation_petition': InformationalNotificationComponent,
  'com.dntl.1l2c.project_member_left': InformationalNotificationComponent,
  'com.dntl.1l2c.project_member_excluded': InformationalNotificationComponent,
  'com.dntl.1l2c.comment_reply': InformationalNotificationComponent,
  'com.dntl.1l2c.post_lead_commented': InformationalNotificationComponent,
  'com.dntl.1l2c.invite_to_community': ConversationalNotificationComponent,
  'com.dntl.1l2c.request_to_join_community': ConversationalNotificationComponent,
  'com.dntl.1l2c.doctor_patient_link_added': ConversationalNotificationComponent,
  'com.dntl.1l2c.doctor_patient_link_removed': InformationalNotificationComponent,
  'com.dntl.1l2c.doctor_patient_link_accepted': InformationalNotificationComponent,
  'com.dntl.1l2c.doctor_patient_link_rejected': InformationalNotificationComponent,
  'com.dntl.1l2c.patient_role_removed': InformationalNotificationComponent,
  'com.dntl.1l2c.doctor_role_removed': InformationalNotificationComponent,
  'com.dntl.1l2c.category_renamed_notification': InformationalNotificationComponent,
};

export const NOTIFICATION_DEFAULT_COMPONENT_TYPE: Type<NotificationContext> = InformationalNotificationComponent;

export const NOTIFICATION_COMPONENT_TYPES: { [key: string]: Type<NotificationContext> } = {
  [NOTIFICATION_ACTION_TYPES.user_get_connection_invitation]: ConversationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.invite_to_project]: ConversationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.request_to_join_project]: ConversationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.user_updated_reactivation_petition]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.request_to_project_accepted]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.request_to_project_decline]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.user_connection_invitation_accepts]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.invite_to_project_accepted]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.invite_to_project_decline]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.invite_to_project_accepted_by_any_owner]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.invite_to_project_decline_by_any_owner]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.project_member_left]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.project_member_excluded]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.post_commented]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.comment_reply]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.post_lead_commented]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.file_shared]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.invite_to_community]: ConversationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.invitation_to_join_community_accepted]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.invitation_to_join_community_declined]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.request_to_join_community]: ConversationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.request_to_join_community_approved]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.request_to_join_community_declined]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.community_member_removed]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.member_left_community]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.doctor_patient_link_added]: ConversationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.doctor_patient_link_removed]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.doctor_patient_link_accepted]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.doctor_patient_link_rejected]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.patient_role_removed]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.doctor_role_removed]: InformationalNotificationComponent,
  [NOTIFICATION_ACTION_TYPES.category_renamed]: InformationalNotificationComponent,
};

export const NOTIFICATION_TEXTS: { [key: string]: string | string[] } = {
  [NOTIFICATION_ACTION_TYPES.user_get_connection_invitation]:
    'NOTIFICATION_ACTION_TYPES_USER_GET_CONNECTION_INVITATION',
  [NOTIFICATION_ACTION_TYPES.invite_to_project]: [
    'NOTIFICATION_ACTION_TYPES_INVITE_TO_PROJECT',
    'NOTIFICATION_ACTION_TYPES_PROJECT',
  ],
  [NOTIFICATION_ACTION_TYPES.request_to_join_project]: [
    'NOTIFICATION_ACTION_TYPES_REQUEST_TO_JOIN_PROJECT',
    'NOTIFICATION_ACTION_TYPES_PROJECT',
  ],
  [NOTIFICATION_ACTION_TYPES.request_to_project_accepted]: 'NOTIFICATION_ACTION_TYPES_REQUEST_TO_PROJECT_ACCEPTED',
  [NOTIFICATION_ACTION_TYPES.request_to_project_decline]: [
    'NOTIFICATION_ACTION_TYPES_REQUEST_TO_PROJECT_DECLINE',
    'NOTIFICATION_ACTION_TYPES_TO_JOIN_THE',
    'NOTIFICATION_ACTION_TYPES_PROJECT',
  ],
  [NOTIFICATION_ACTION_TYPES.user_updated_reactivation_petition]:
    'NOTIFICATION_ACTION_TYPES_USER_UPDATE_REACTIVATION_PETITION',
  [NOTIFICATION_ACTION_TYPES.user_connection_invitation_accepts]:
    'NOTIFICATION_ACTION_TYPES_USER_CONNECTION_INVITATION_ACCEPTS',
  [NOTIFICATION_ACTION_TYPES.invite_to_project_accepted]: [
    'NOTIFICATION_ACTION_TYPES_INVITE_TO_PROJECT_ACCEPTED',
    'NOTIFICATION_ACTION_TYPES_PROJECT',
  ],
  [NOTIFICATION_ACTION_TYPES.invite_to_project_decline]: [
    'NOTIFICATION_ACTION_TYPES_INVITE_TO_PROJECT_DECLINE',
    'NOTIFICATION_ACTION_TYPES_PROJECT',
  ],
  [NOTIFICATION_ACTION_TYPES.invite_to_project_accepted_by_any_owner]: [
    'NOTIFICATION_ACTION_TYPES_INVITE_TO_PROJECT_ACCEPTED_BY_ANY_OWNER',
    'NOTIFICATION_ACTION_TYPES_TO_JOIN_THE',
    'NOTIFICATION_ACTION_TYPES_PROJECT',
  ],
  [NOTIFICATION_ACTION_TYPES.invite_to_project_decline_by_any_owner]: [
    'NOTIFICATION_ACTION_TYPES_INVITE_TO_PROJECT_DECLINE_BY_ANY_OWNER',
    'NOTIFICATION_ACTION_TYPES_TO_JOIN_THE',
    'NOTIFICATION_ACTION_TYPES_PROJECT',
  ],
  [NOTIFICATION_ACTION_TYPES.project_member_left]: 'NOTIFICATION_ACTION_TYPES_PROJECT_MEMBER_LEFT',
  [NOTIFICATION_ACTION_TYPES.project_member_excluded]: 'NOTIFICATION_ACTION_TYPES_PROJECT_MEMBER_EXCLUDED',
  [NOTIFICATION_ACTION_TYPES.post_commented]: 'NOTIFICATION_ACTION_TYPES_POST_COMMENTED',
  [NOTIFICATION_ACTION_TYPES.comment_reply]: 'NOTIFICATION_ACTION_TYPES_COMMENT_REPLY',
  [NOTIFICATION_ACTION_TYPES.post_lead_commented]: [
    'NOTIFICATION_ACTION_TYPES_LEAD_POST_COMMENTED',
    'NOTIFICATION_ACTION_TYPES_LEAD_POST_PROJECT',
    'NOTIFICATION_ACTION_TYPES_LEAD_POST_COMMUNITY',
  ],
  [NOTIFICATION_ACTION_TYPES.file_shared]: [
    'NOTIFICATION_ACTION_TYPES_FILE_SHARED',
    'NOTIFICATION_ACTION_FILE_WITH_YOU',
  ],
  [NOTIFICATION_ACTION_TYPES.invite_to_community]: [
    'NOTIFICATION_ACTION_TYPES_INVITE_TO_COMMUNITY',
    'NOTIFICATION_ACTION_TYPES_COMMUNITY',
  ],
  [NOTIFICATION_ACTION_TYPES.member_left_community]: 'NOTIFICATION_ACTION_TYPES_MEMBER_LEFT_COMMUNITY',
  [NOTIFICATION_ACTION_TYPES.invitation_to_join_community_accepted]: [
    'NOTIFICATION_ACTION_TYPES_INVITATION_TO_JOIN_COMMUNITY_ACCEPTED',
    'NOTIFICATION_ACTION_TYPES_COMMUNITY',
  ],
  [NOTIFICATION_ACTION_TYPES.invitation_to_join_community_declined]: [
    'NOTIFICATION_ACTION_TYPES_INVITATION_TO_JOIN_COMMUNITY_DECLINED',
    'NOTIFICATION_ACTION_TYPES_COMMUNITY',
  ],
  [NOTIFICATION_ACTION_TYPES.request_to_join_community]: 'NOTIFICATION_ACTION_TYPES_REQUEST_TO_JOIN_COMMUNITY',
  [NOTIFICATION_ACTION_TYPES.request_to_join_community_approved]:
    'NOTIFICATION_ACTION_TYPES_REQUEST_TO_JOIN_COMMUNITY_APPROVED',
  [NOTIFICATION_ACTION_TYPES.request_to_join_community_declined]: [
    'NOTIFICATION_ACTION_TYPES_REQUEST_TO_JOIN_PRIVATE_COMMUNITY',
    'NOTIFICATION_ACTION_TYPES_REQUEST_TO_JOIN_COMMUNITY_DECLINED',
  ],

  [NOTIFICATION_ACTION_TYPES.community_member_removed]: [
    'NOTIFICATION_ACTION_TYPES_COMMUNITY_MEMBER_REMOVED',
    'NOTIFICATION_ACTION_TYPES_COMMUNITY',
  ],
  [NOTIFICATION_ACTION_TYPES.doctor_patient_link_added]: [
    'NOTIFICATION_ACTION_TYPES_DOCTOR_ROLE',
    'NOTIFICATION_ACTION_TYPES_PATIENT_ROLE',
    'NOTIFICATION_ACTION_TYPES_TO_VERIFY_DOCTOR_PATIENT_LINK',
  ],
  [NOTIFICATION_ACTION_TYPES.doctor_patient_link_accepted]: [
    'NOTIFICATION_ACTION_TYPES_DOCTOR_ROLE',
    'NOTIFICATION_ACTION_TYPES_PATIENT_ROLE',
    'NOTIFICATION_ACTION_TYPES_DOCTOR_PATIENT_LINK_ACCEPTED',
  ],
  [NOTIFICATION_ACTION_TYPES.doctor_patient_link_rejected]: [
    'NOTIFICATION_ACTION_TYPES_DOCTOR_ROLE',
    'NOTIFICATION_ACTION_TYPES_PATIENT_ROLE',
    'NOTIFICATION_ACTION_TYPES_DOCTOR_PATIENT_LINK_REJECTED',
  ],
  [NOTIFICATION_ACTION_TYPES.doctor_patient_link_removed]: [
    'NOTIFICATION_ACTION_TYPES_DOCTOR_ROLE',
    'NOTIFICATION_ACTION_TYPES_PATIENT_ROLE',
    'NOTIFICATION_ACTION_TYPES_DOCTOR_PATIENT_LINK_REMOVED',
  ],
  [NOTIFICATION_ACTION_TYPES.patient_role_removed]: 'NOTIFICATION_ACTION_TYPES_PATIENT_ROLE_REMOVED',
  [NOTIFICATION_ACTION_TYPES.doctor_role_removed]: 'NOTIFICATION_ACTION_TYPES_DOCTOR_ROLE_REMOVED',
  [NOTIFICATION_ACTION_TYPES.category_renamed]: [
    'CATEGORY_RENAMED_THE',
    'CATEGORY_RENAMED_IS_RENAMED_TO',
    'CATEGORY_RENAMED_THROUGHOUT_THE_SYSTEM',
  ],
};
